import { IsNotEmpty, IsString } from 'class-validator';

export class NodeToSignDto {
  @IsString()
  @IsNotEmpty()
  signature: string;

  @IsString()
  @IsNotEmpty()
  document_hash: string;
}
